import styled from 'styled-components';
import {
  FormControl,
  Divider as MuiDivider,
  IconButton as MuiIconButton,
  Chip as MuiChip
} from '@mui/material';

export const Box = styled.div`
  position: absolute;
  border-radius: 5px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  min-width: 300px;
  max-width: 1000px;
  background-color: white;
  height: auto;
  min-height: 200px;
  max-height: 95%;
  padding: 10px;
  overflow-y: auto;
`;

export const Content = styled.div`
  width: 100%;
  padding: 20px;
  padding-top: 0px;
`;

export const Form = styled(FormControl)`
  width: 100%;
`;

export const Header = styled.div`
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
`;

export const Divider = styled(MuiDivider)`
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const Bottom = styled.div`
  margin-top: 20px;
  text-align: right;
`;

export const IconButton = styled(MuiIconButton)`
  position: absolute !important;
  right: 10px;
  top: 10px;
`;

export const Chip = styled(MuiChip)`
  margin-right: 10px;
`;

export const FormTextFieldContainer = styled.div`
  flexgrow: 1;
  margin-top: 20px;
`;

export const CloneDashboardContainer = styled.div`
  margin-bottom: 2px;
`;
